import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';
import { Button }  from "@mui/material";
import { fni18n } from "../../services/commonService";

/**
 * @param { open(boolean), onClose(function), onClickOk(function), title(string), message(string) } props 
 * @returns 
 * @author minjlee
 * @since 2023. 03.10
 * @version 0.1
 */
const UConfirmDialog = (props) => {
    return (
        <div>
            <Dialog
                open={props.open}
                onClose={props.onClose}
                PaperComponent={PaperComponent}
                aria-labelledby="draggable-dialog-title"
                fullWidth={true}
            >
                <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                    { props.title || fni18n("확인") }
                </DialogTitle>
                <DialogContent>
                <DialogContentText>
                    {fni18n(props.message)}
                </DialogContentText>
                </DialogContent>
                <DialogActions>
                <Button variant="outlined" onClick={props.onClose}>Cancel</Button>
                <Button variant="contained" autoFocus onClick={()=>{props.onClickOk()}}>Ok</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}
export default UConfirmDialog;

function PaperComponent(props) {
    return (
      <Draggable
        handle="#draggable-dialog-title"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} />
      </Draggable>
    );
}